(function () {
  function normalizeRoutePath(routeValue, fallback) {
    var value = typeof routeValue === 'string' && routeValue ? routeValue : fallback;
    if (value.indexOf('http://') === 0 || value.indexOf('https://') === 0) {
      try {
        var parsed = new URL(value);
        return parsed.pathname || fallback;
      } catch (error) {
        return fallback;
      }
    }
    return value;
  }

  function initHeaderDrawer(root) {
    if (!root || root.dataset.roomsHeaderInit === 'true') return;
    root.dataset.roomsHeaderInit = 'true';

    var toggleButton = root.querySelector('[data-rooms-header-menu-toggle]');
    var headerSection = root.closest('.section-rooms-header') || document;
    if (!toggleButton) return;

    var drawer = headerSection.querySelector('[data-rooms-header-drawer]');
    if (!drawer) return;

    var closeButtons = drawer.querySelectorAll('[data-rooms-header-menu-close]');
    var drawerLinks = drawer.querySelectorAll('.rooms-header-drawer__link');

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      toggleButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('rooms-menu-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      toggleButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('rooms-menu-open');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 240);
    }

    toggleButton.addEventListener('click', function () {
      if (drawer.hidden) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    drawerLinks.forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) {
        closeDrawer();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 767 && !drawer.hidden) {
        closeDrawer();
      }
    });
  }

  function initHeaderScrollRelease() {
    var headerSection = document.querySelector('.section-rooms-header');
    if (!headerSection || headerSection.dataset.roomsScrollReleaseInit === 'true') return;
    headerSection.dataset.roomsScrollReleaseInit = 'true';

    var releaseOffset = 200;
    var lastScrollY = window.scrollY || 0;
    var ticking = false;

    function updateHeader() {
      ticking = false;
      var currentScrollY = window.scrollY || 0;
      var isScrollingDown = currentScrollY > lastScrollY;
      var shouldRelease = currentScrollY > releaseOffset && isScrollingDown && !document.body.classList.contains('rooms-menu-open');
      headerSection.classList.toggle('is-rooms-header-released', shouldRelease);
      lastScrollY = currentScrollY;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    updateHeader();
  }

  function updateHeaderCartUI(itemCount) {
    var cartButtons = document.querySelectorAll('[data-rooms-cart-button]');
    cartButtons.forEach(function (button) {
      var countNode = button.querySelector('[data-rooms-cart-count]');
      var fullIcon = button.querySelector('[data-rooms-cart-icon-full]');
      var emptyIcon = button.querySelector('[data-rooms-cart-icon-empty]');

      if (countNode) {
        countNode.textContent = String(itemCount);
        countNode.classList.toggle('is-hidden', itemCount === 0);
      }

      if (fullIcon) {
        fullIcon.classList.toggle('is-hidden', itemCount === 0);
      }

      if (emptyIcon) {
        emptyIcon.classList.toggle('is-hidden', itemCount > 0);
      }
    });
  }

  function initHeaderCartUpdates() {
    if (document.documentElement.dataset.roomsHeaderCartUpdatesInit === 'true') return;
    document.documentElement.dataset.roomsHeaderCartUpdatesInit = 'true';

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (!cartData || typeof cartData.item_count !== 'number') return;
      updateHeaderCartUI(cartData.item_count);
    });
  }

  function refreshHeaderCartCount() {
    var cartUrl = normalizeRoutePath(window.routes && window.routes.cart_url, '/cart');
    return fetch(cartUrl + '.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function (cart) {
        var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        updateHeaderCartUI(itemCount);
      })
      .catch(function () {
        return null;
      });
  }

  function getCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return null;
    return drawer;
  }

  function openCartDrawer(triggerElement) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return false;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open(triggerElement);
      return true;
    }

    window.setTimeout(function () {
      var upgradedDrawer = document.querySelector('cart-drawer');
      if (upgradedDrawer && typeof upgradedDrawer.open === 'function') {
        upgradedDrawer.open(triggerElement);
      }
    }, 0);
    return true;
  }

  function initHeaderCartButtons() {
    var cartButtons = document.querySelectorAll('[data-rooms-cart-button]');
    if (!cartButtons.length) return;

    cartButtons.forEach(function (button) {
      if (button.dataset.roomsCartButtonInit === 'true') return;
      button.dataset.roomsCartButtonInit = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        openCartDrawer(button);
      });
    });
  }

  function initCoffeeAddToCart() {
    var forms = document.querySelectorAll(
      '.rooms-coffee-page-card__form, .rooms-coffee-select-card__form, .rooms-product-coffee__form, .rooms-product-recommend-gift__coffee-form'
    );
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.dataset.roomsCoffeeAjaxInit === 'true') return;
      form.dataset.roomsCoffeeAjaxInit = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector(
          '.rooms-coffee-page-card__add, .rooms-coffee-select-card__add, .rooms-product-coffee__add, .rooms-product-recommend-gift__coffee-add'
        );
        var variantInput = form.querySelector('[name="id"]');
        if (!button || button.disabled || !variantInput || !variantInput.value) return;

        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput ? Number(quantityInput.value || '1') : 1;
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
        if (quantityInput) quantityInput.value = quantity;

        var formData = new FormData(form);
        var cartDrawer = getCartDrawer();
        var addUrl = normalizeRoutePath(window.routes && window.routes.cart_add_url, '/cart/add');
        var variantId = Number(variantInput.value);
        if (!Number.isFinite(variantId) || variantId <= 0) return;

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map(function (section) {
                return section.id;
              })
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(document.activeElement);
          }
        }

        var usesCardStyles =
          button.classList.contains('rooms-coffee-page-card__add') ||
          button.classList.contains('rooms-coffee-select-card__add') ||
          button.classList.contains('rooms-product-recommend-gift__coffee-add');

        if (usesCardStyles) {
          button.classList.add('loading');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.classList.add('is-loading');
        }
        button.disabled = true;

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (parsed) {
              if (!response.ok || parsed.status) {
                throw new Error((parsed && (parsed.description || parsed.message)) || 'Add to cart failed');
              }
              return parsed;
            });
          })
          .then(function (parsed) {
            if (cartDrawer && parsed.sections) {
              cartDrawer.renderContents(parsed);
            }
            return refreshHeaderCartCount();
          })
          .catch(function (error) {
            if (window.console && typeof window.console.error === 'function') {
              window.console.error('Coffee add-to-cart failed:', error);
            }
          })
          .finally(function () {
            if (usesCardStyles) {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
            } else {
              button.classList.remove('is-loading');
            }
            if (!variantInput.disabled) {
              button.disabled = false;
            }
          });
      });
    });
  }

  function initGiftProductAddToCart() {
    var forms = document.querySelectorAll('.rooms-product-gift__form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.dataset.roomsGiftAjaxInit === 'true') return;
      form.dataset.roomsGiftAjaxInit = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector('.rooms-product-gift__add');
        var variantInput = form.querySelector('[name="id"]');
        if (!button || button.disabled || !variantInput || !variantInput.value) return;

        var formData = new FormData(form);
        var cartDrawer = getCartDrawer();
        var addUrl = normalizeRoutePath(window.routes && window.routes.cart_add_url, '/cart/add');
        var variantId = Number(variantInput.value);
        if (!Number.isFinite(variantId) || variantId <= 0) return;

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map(function (section) {
                return section.id;
              })
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(document.activeElement);
          }
        }

        button.classList.add('is-loading');
        button.disabled = true;

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (parsed) {
              if (!response.ok || parsed.status) {
                throw new Error((parsed && (parsed.description || parsed.message)) || 'Add to cart failed');
              }
              return parsed;
            });
          })
          .then(function (parsed) {
            if (cartDrawer && parsed.sections) {
              cartDrawer.renderContents(parsed);
            }
            return refreshHeaderCartCount();
          })
          .catch(function (error) {
            if (window.console && typeof window.console.error === 'function') {
              window.console.error('Gift add-to-cart failed:', error);
            }
          })
          .finally(function () {
            button.classList.remove('is-loading');
            if (!variantInput.disabled) {
              button.disabled = false;
            }
          });
      });
    });
  }

  function initGiftAccordions() {
    var accordions = document.querySelectorAll('.rooms-product-gift__accordion');
    if (!accordions.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    accordions.forEach(function (accordion) {
      if (accordion.dataset.roomsAccordionInit === 'true') return;
      accordion.dataset.roomsAccordionInit = 'true';

      var summary = accordion.querySelector('.rooms-product-gift__accordion-summary');
      var content = accordion.querySelector('.rooms-product-gift__accordion-content');
      if (!summary || !content) return;

      if (prefersReducedMotion) return;

      function setOpenState() {
        if (accordion.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
        } else {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
        }
      }

      setOpenState();

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (!accordion.open) {
          accordion.open = true;
          content.style.maxHeight = '0px';
          content.style.opacity = '0';

          requestAnimationFrame(function () {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.opacity = '1';
          });
          return;
        }

        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';

        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
        });

        var onCollapseEnd = function (transitionEvent) {
          if (transitionEvent.propertyName !== 'max-height') return;
          accordion.open = false;
          content.removeEventListener('transitionend', onCollapseEnd);
        };
        content.addEventListener('transitionend', onCollapseEnd);
      });

      window.addEventListener('resize', function () {
        if (accordion.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  function bindMouseDragScroll(viewport) {
    var dragThreshold = 2;
    var viewportDragging = false;
    var viewportMoved = false;
    var viewportMovedEnoughToCancelClick = false;
    var viewportStartX = 0;
    var viewportStartScroll = 0;
    var activePointerId = null;
    var nextScrollLeft = 0;
    var scrollFrame = null;

    function applyScroll() {
      scrollFrame = null;
      viewport.scrollLeft = nextScrollLeft;
    }

    function requestScroll(left) {
      nextScrollLeft = left;
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(applyScroll);
    }

    viewport.addEventListener('dragstart', function (event) {
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (event.target.closest('a, img')) {
        event.preventDefault();
      }
    });

    viewport.addEventListener('pointerdown', function (event) {
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (event.button !== 0) return;
      viewportDragging = true;
      viewportMoved = false;
      viewportMovedEnoughToCancelClick = false;
      viewportStartX = event.clientX;
      viewportStartScroll = viewport.scrollLeft;
      activePointerId = event.pointerId;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (!viewportDragging || event.pointerId !== activePointerId) return;

      var delta = event.clientX - viewportStartX;
      if (Math.abs(delta) <= dragThreshold && !viewportMoved) return;

      viewportMoved = true;
      if (Math.abs(delta) > 5) viewportMovedEnoughToCancelClick = true;
      if (!viewport.hasPointerCapture(event.pointerId)) {
        viewport.setPointerCapture(event.pointerId);
      }
      viewport.classList.add('is-dragging');
      requestScroll(viewportStartScroll - delta);
      event.preventDefault();
    });

    function stopViewportDragging(event) {
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (!viewportDragging) return;
      viewportDragging = false;
      activePointerId = null;
      viewport.classList.remove('is-dragging');
      if (scrollFrame !== null) {
        window.cancelAnimationFrame(scrollFrame);
        applyScroll();
      }
      if (event && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
    }

    viewport.addEventListener('pointerup', stopViewportDragging);
    viewport.addEventListener('pointercancel', stopViewportDragging);
    viewport.addEventListener(
      'click',
      function (event) {
        if (window.matchMedia('(pointer: coarse)').matches) return;
        if (!viewportMovedEnoughToCancelClick) return;
        event.preventDefault();
        event.stopPropagation();
        viewportMoved = false;
        viewportMovedEnoughToCancelClick = false;
      },
      true
    );
  }

  function initArchiveSlider(section) {
    if (section.dataset.roomsArchiveSliderInit === 'true') return;

    var viewport = section.querySelector('[data-rooms-archive-viewport]');
    var track = section.querySelector('[data-rooms-archive-track]');
    var thumb = section.querySelector('[data-rooms-archive-thumb]');
    var cardsWrap = section.querySelector('.rooms-events-archives--slider');
    var sliderContainer = track ? track.closest('.rooms-events-archive__slider') : null;

    if (!viewport || !track || !thumb || !cardsWrap) return;

    section.dataset.roomsArchiveSliderInit = 'true';

    var dragging = false;
    var startX = 0;
    var startLeft = 0;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function resetArchiveCardLayout() {
      var cards = Array.prototype.slice.call(cardsWrap.querySelectorAll('.rooms-events-archive-card'));
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.style.flexBasis = '';
        card.style.width = '';
      });
      cardsWrap.style.width = '';
    }

    function updateThumb() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var hasOverflow = maxScroll > 1;

      viewport.classList.toggle('is-slider', hasOverflow);
      if (sliderContainer) {
        sliderContainer.hidden = !hasOverflow;
      }

      if (!hasOverflow) {
        viewport.scrollLeft = 0;
        thumb.style.width = track.clientWidth + 'px';
        thumb.style.left = '0px';
        return;
      }

      var visibleRatio = viewport.clientWidth / viewport.scrollWidth;
      var thumbWidth = Math.max(track.clientWidth * visibleRatio, 48);
      var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
      var scrollRatio = viewport.scrollLeft / maxScroll;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.left = maxThumbLeft * scrollRatio + 'px';
    }

    function syncScrollFromThumb(nextLeft) {
      var thumbWidth = thumb.offsetWidth;
      var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
      var clampedLeft = clamp(nextLeft, 0, maxThumbLeft);
      var ratio = maxThumbLeft > 0 ? clampedLeft / maxThumbLeft : 0;
      var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

      viewport.scrollLeft = ratio * maxScroll;
    }

    thumb.addEventListener('pointerdown', function (event) {
      dragging = true;
      startX = event.clientX;
      startLeft = thumb.offsetLeft;
      viewport.classList.add('is-dragging');
      thumb.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    thumb.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      syncScrollFromThumb(startLeft + (event.clientX - startX));
    });

    function stopDragging(event) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (event && thumb.hasPointerCapture(event.pointerId)) {
        thumb.releasePointerCapture(event.pointerId);
      }
    }

    thumb.addEventListener('pointerup', stopDragging);
    thumb.addEventListener('pointercancel', stopDragging);

    track.addEventListener('pointerdown', function (event) {
      if (event.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var targetLeft = event.clientX - rect.left - thumb.offsetWidth / 2;
      syncScrollFromThumb(targetLeft);
    });

    bindMouseDragScroll(viewport);

    viewport.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', function () {
      resetArchiveCardLayout();
      updateThumb();
    });

    resetArchiveCardLayout();
    updateThumb();
  }

  function initCoffeeSlider(section) {
    if (section.dataset.roomsCoffeeSliderInit === 'true') return;

    var viewport = section.querySelector('[data-rooms-coffee-viewport]');
    var track = section.querySelector('[data-rooms-coffee-track]');
    var thumb = section.querySelector('[data-rooms-coffee-thumb]');
    var products = section.querySelector('.rooms-coffee__products--slider');
    var sliderContainer = track ? track.closest('.rooms-coffee__slider') : null;

    if (!viewport || !track || !thumb || !products) return;

    section.dataset.roomsCoffeeSliderInit = 'true';

    var dragging = false;
    var startX = 0;
    var startLeft = 0;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function resetCoffeeCardLayout() {
      var cards = Array.prototype.slice.call(products.querySelectorAll('.rooms-coffee-card'));
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.style.flexBasis = '';
        card.style.width = '';
      });
      products.style.width = '';
    }

    function updateThumb() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var hasOverflow = maxScroll > 1;

      viewport.classList.toggle('is-slider', hasOverflow);
      if (sliderContainer) {
        sliderContainer.hidden = !hasOverflow;
      }

      if (!hasOverflow) {
        viewport.scrollLeft = 0;
        thumb.style.width = track.clientWidth + 'px';
        thumb.style.left = '0px';
        return;
      }

      var visibleRatio = viewport.clientWidth / viewport.scrollWidth;
      var thumbWidth = Math.max(track.clientWidth * visibleRatio, 48);
      var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
      var scrollRatio = viewport.scrollLeft / maxScroll;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.left = maxThumbLeft * scrollRatio + 'px';
    }

    function syncScrollFromThumb(nextLeft) {
      var thumbWidth = thumb.offsetWidth;
      var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
      var clampedLeft = clamp(nextLeft, 0, maxThumbLeft);
      var ratio = maxThumbLeft > 0 ? clampedLeft / maxThumbLeft : 0;
      var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

      viewport.scrollLeft = ratio * maxScroll;
    }

    thumb.addEventListener('pointerdown', function (event) {
      dragging = true;
      startX = event.clientX;
      startLeft = thumb.offsetLeft;
      viewport.classList.add('is-dragging');
      thumb.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    thumb.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      syncScrollFromThumb(startLeft + (event.clientX - startX));
    });

    function stopDragging(event) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (event && thumb.hasPointerCapture(event.pointerId)) {
        thumb.releasePointerCapture(event.pointerId);
      }
    }

    thumb.addEventListener('pointerup', stopDragging);
    thumb.addEventListener('pointercancel', stopDragging);

    track.addEventListener('pointerdown', function (event) {
      if (event.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var targetLeft = event.clientX - rect.left - thumb.offsetWidth / 2;
      syncScrollFromThumb(targetLeft);
    });

    bindMouseDragScroll(viewport);

    viewport.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', function () {
      resetCoffeeCardLayout();
      updateThumb();
    });

    resetCoffeeCardLayout();
    updateThumb();
  }

  function initRecommendGiftSliders(section) {
    if (section.dataset.roomsRecommendGiftSlidersInit === 'true') return;

    var scrollbars = Array.prototype.slice.call(section.querySelectorAll('[data-rooms-recommend-gift-scrollbar]'));
    if (!scrollbars.length) return;

    section.dataset.roomsRecommendGiftSlidersInit = 'true';

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    scrollbars.forEach(function (scrollbar) {
      var viewport = scrollbar.previousElementSibling;
      var track = scrollbar.querySelector('[data-rooms-recommend-gift-track]');
      var thumb = scrollbar.querySelector('[data-rooms-recommend-gift-thumb]');
      if (!viewport || !track || !thumb) return;

      var dragging = false;
      var startX = 0;
      var startLeft = 0;

      function updateThumb() {
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var hasOverflow = maxScroll > 1;

        scrollbar.hidden = !hasOverflow;

        if (!hasOverflow) {
          viewport.scrollLeft = 0;
          thumb.style.width = track.clientWidth + 'px';
          thumb.style.left = '0px';
          return;
        }

        var visibleRatio = viewport.clientWidth / viewport.scrollWidth;
        var thumbWidth = Math.max(track.clientWidth * visibleRatio, 48);
        var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
        var scrollRatio = viewport.scrollLeft / maxScroll;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.left = maxThumbLeft * scrollRatio + 'px';
      }

      function syncScrollFromThumb(nextLeft) {
        var thumbWidth = thumb.offsetWidth;
        var maxThumbLeft = Math.max(track.clientWidth - thumbWidth, 0);
        var clampedLeft = clamp(nextLeft, 0, maxThumbLeft);
        var ratio = maxThumbLeft > 0 ? clampedLeft / maxThumbLeft : 0;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

        viewport.scrollLeft = ratio * maxScroll;
      }

      thumb.addEventListener('pointerdown', function (event) {
        dragging = true;
        startX = event.clientX;
        startLeft = thumb.offsetLeft;
        thumb.setPointerCapture(event.pointerId);
      });

      thumb.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        syncScrollFromThumb(startLeft + (event.clientX - startX));
      });

      function stopDragging(event) {
        if (!dragging) return;
        dragging = false;
        if (event && thumb.hasPointerCapture(event.pointerId)) {
          thumb.releasePointerCapture(event.pointerId);
        }
      }

      thumb.addEventListener('pointerup', stopDragging);
      thumb.addEventListener('pointercancel', stopDragging);

      track.addEventListener('pointerdown', function (event) {
        if (event.target === thumb) return;
        var rect = track.getBoundingClientRect();
        var targetLeft = event.clientX - rect.left - thumb.offsetWidth / 2;
        syncScrollFromThumb(targetLeft);
      });

      viewport.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb);
      updateThumb();
    });
  }

  function initHero(section) {
    var videos = Array.prototype.slice.call(section.querySelectorAll('[data-rooms-hero-video]'));
    var button = section.querySelector('[data-rooms-mute-toggle]');

    if (!videos.length || !button) return;

    var muteLabel = button.getAttribute('data-label-muted') || 'Unmute video';
    var unmuteLabel = button.getAttribute('data-label-unmuted') || 'Mute video';

    function sync() {
      var activeVideo = videos.find(function (item) {
        return item.offsetParent !== null;
      }) || videos[0];
      var isMuted = activeVideo.muted;
      button.setAttribute('aria-pressed', String(!isMuted));
      button.setAttribute('aria-label', isMuted ? muteLabel : unmuteLabel);
      button.classList.toggle('is-unmuted', !isMuted);

      var icon = button.querySelector('.rooms-hero__mute-icon');
      if (icon) {
        icon.textContent = isMuted ? 'M' : 'S';
      }
    }

    button.addEventListener('click', function () {
      var activeVideo = videos.find(function (item) {
        return item.offsetParent !== null;
      }) || videos[0];
      var nextMuted = !activeVideo.muted;
      videos.forEach(function (item) {
        item.muted = nextMuted;
      });
      sync();
    });

    videos.forEach(function (item) {
      item.addEventListener('volumechange', sync);
    });
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-rooms-header-root]').forEach(initHeaderDrawer);
    initHeaderScrollRelease();
    initHeaderCartButtons();
    initHeaderCartUpdates();
    document.querySelectorAll('[data-rooms-hero-section]').forEach(initHero);
    document.querySelectorAll('[data-rooms-coffee-section]').forEach(initCoffeeSlider);
    document.querySelectorAll('[data-rooms-archive-section]').forEach(initArchiveSlider);
    initCoffeeAddToCart();
    initGiftProductAddToCart();
    initGiftAccordions();
    document.querySelectorAll('[data-rooms-product-recommend-gift]').forEach(initRecommendGiftSliders);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container) return;
    container.querySelectorAll('[data-rooms-header-root]').forEach(initHeaderDrawer);
    initHeaderScrollRelease();
    initHeaderCartButtons();
    initHeaderCartUpdates();
    var section = container.querySelector('[data-rooms-hero-section]');
    if (section) initHero(section);
    container.querySelectorAll('[data-rooms-coffee-section]').forEach(initCoffeeSlider);
    container.querySelectorAll('[data-rooms-archive-section]').forEach(initArchiveSlider);
    initCoffeeAddToCart();
    initGiftProductAddToCart();
    initGiftAccordions();
    container.querySelectorAll('[data-rooms-product-recommend-gift]').forEach(initRecommendGiftSliders);
  });
})();
